module.exports = __webpack_public_path__ + "main/assets/public/icons/plus-icon.419652eeb6c5ce6b.svg";